import WebApp from "../components/WebApp";

const Team = () => {
  return (
    <WebApp>
      <div>
          Team
      </div>
    </WebApp>
  );
};


export default Team;